import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Section } from './ui/Section';
const features = [{
  que: 'Planificación anual lista para entregar a dirección',
  para: 'Cumplís con la exigencia administrativa en minutos, no en horas'
}, {
  que: 'Secuencia didáctica semanal por unidad curricular',
  para: 'Sabés exactamente qué dar cada semana sin improvisar'
}, {
  que: 'Fichas de alumno fotocopiables',
  para: 'Material listo para imprimir y repartir el mismo lunes'
}, {
  que: 'Evaluaciones + criterios de corrección',
  para: 'Evaluás con criterio claro y fundamentado'
}, {
  que: 'Rúbricas alineadas al Programa EBI vigente',
  para: 'Valoración profesional y defendible ante cualquier inspección'
}, {
  que: 'Fichas de seguimiento individual por alumno',
  para: 'Registrás el proceso real de cada niño durante el año'
}, {
  que: 'Actividades diferenciadas por nivel de logro',
  para: 'Atendés la diversidad del grupo sin armar material extra'
}, {
  que: '100% alineado al Programa EBI — ANEP 2025',
  para: 'Sin adaptaciones. Sin riesgos. Sin retrabajos de último momento.'
}];
export const IncludesTable = () => {
  return <Section background="white" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        <div className="text-center mb-10" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-176">
            ✅ CADA TOMO INCLUYE:
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden" data-id="element-177">
          <div className="hidden md:grid grid-cols-2 bg-stone-50 border-b border-stone-200" data-id="element-178">
            <div className="p-5 font-bold text-stone-700" data-id="element-179">Qué encontrás</div>
            <div className="p-5 font-bold text-stone-700 border-l border-stone-200" data-id="element-180">
              Para qué sirve
            </div>
          </div>

          <div className="divide-y divide-stone-100" data-id="element-181">
            {features.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="grid md:grid-cols-2 hover:bg-stone-50/50 transition-colors" data-id="element-182">
                <div className="p-4 md:p-5 flex items-start gap-3" data-id="element-183">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-184" />
                  <span className="font-bold text-stone-800" data-id="element-185">{item.que}</span>
                </div>
                <div className="p-4 md:p-5 pt-0 md:pt-5 text-stone-600 md:border-l border-stone-100 flex items-start" data-id="element-186">
                  <span className="md:hidden text-xs font-bold text-stone-400 uppercase mr-2 mt-1" data-id="element-187">
                    Sirve para:
                  </span>
                  {item.para}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </Section>;
};